import React, { useState } from 'react';

function MultiSelectFilter({ options, selectedValues, onChange, placeholder = "Select options..." }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionToggle = (value) => {
    const newSelection = selectedValues.includes(value)
      ? selectedValues.filter(v => v !== value)
      : [...selectedValues, value];
    onChange(newSelection);
  };

  const handleSelectAll = () => {
    if (selectedValues.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map(opt => opt.value));
    }
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const option = options.find(opt => opt.value === selectedValues[0]);
      return option ? option.label : selectedValues[0];
    }
    return `${selectedValues.length} selected`;
  };

  return (
    <div className="multi-select-container" style={{ position: 'relative' }}>
      <div 
        className="multi-select-trigger"
        tabIndex={0}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
          if (e.key === 'Escape') {
            setIsOpen(false);
          }
        }}

        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.75rem',
          border: isOpen ? '1px solid #667eea' : '1px solid #d1d5db',
          borderRadius: '8px',
          backgroundColor: 'white',
          cursor: 'pointer',
          fontSize: '1rem',
          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
          boxShadow: isOpen ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : 'none'
        }}
      >
        <span style={{ 
          color: selectedValues.length === 0 ? '#9ca3af' : 'inherit',
          fontSize: '1rem'
        }}>
          {getDisplayText()}
        </span>
        <span style={{ 
          fontSize: '0.75rem',
          color: '#6b7280',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
          lineHeight: 1,
          userSelect: 'none'
        }}>
          ▼
        </span>
      </div>
      
      {isOpen && (
        <div 
          className="multi-select-dropdown"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            border: '1px solid #667eea',
            borderTop: 'none',
            borderRadius: '0 0 8px 8px',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            maxHeight: '200px',
            overflowY: 'auto'
          }}
        >
          <div 
            className="multi-select-option"
            onClick={handleSelectAll}
            style={{
              padding: '0.75rem',
              cursor: 'pointer',
              borderBottom: '1px solid #f3f4f6',
              fontWeight: '600',
              fontSize: '0.875rem',
              color: '#374151',
              transition: 'background-color 0.15s ease'
            }}

          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ 
                width: '18px',
                height: '18px',
                border: '2px solid #d1d5db',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: selectedValues.length === options.length ? '#667eea' : 'white',
                borderColor: selectedValues.length === options.length ? '#667eea' : '#d1d5db',
                color: 'white',
                fontSize: '11px',
                fontWeight: 'bold',
                transition: 'all 0.15s ease',
                flexShrink: 0
              }}>
                {selectedValues.length === options.length ? '✓' : ''}
              </span>
              <span>{selectedValues.length === options.length ? 'Deselect All' : 'Select All'}</span>
            </span>
          </div>
          
          {options.map((option) => (
            <div
              key={option.value}
              className="multi-select-option"
              onClick={() => handleOptionToggle(option.value)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.75rem',
                cursor: 'pointer',
                fontSize: '0.875rem',
                color: '#374151',
                transition: 'background-color 0.15s ease'
              }}

            >
              <span style={{ 
                width: '18px',
                height: '18px',
                border: '2px solid #d1d5db',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: selectedValues.includes(option.value) ? '#667eea' : 'white',
                borderColor: selectedValues.includes(option.value) ? '#667eea' : '#d1d5db',
                color: 'white',
                fontSize: '11px',
                fontWeight: 'bold',
                transition: 'all 0.15s ease',
                flexShrink: 0
              }}>
                {selectedValues.includes(option.value) ? '✓' : ''}
              </span>
              <span>{option.emoji} {option.label}</span>
            </div>
          ))}
        </div>
      )}
      
      {/* Overlay to close dropdown when clicking outside */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default MultiSelectFilter; 